import React, { FC } from 'react';
import { head } from 'ramda';
import { captureException } from '@sentry/react';
import {
  FileAwarenessMonitorErrorsList,
  FileAwarenessMonitorErrorTypeTag,
  withFileUsedParam,
} from '@wix/media-manager-shared';

import { VideoPlayer } from '../../../../components/common';
import { MediaManagerSDKFile } from '../../../../utils/media-manager-sdk';
import { useVideoPreviews } from '../../../../utils/media-manager-sdk/hooks';
import { IOuter } from '../ItemDemonstration.types';

const playerConfig = { hideOverlay: true };

export const Video: FC<IOuter> = ({ item, className, saveRef }) => (
  <div className={className} data-hook="expanded-view-video-demonstration" ref={saveRef}>
    <VideoPlayer
      autoplay
      src={withFileUsedParam(head(useVideoPreviews(item as MediaManagerSDKFile)), {
        logger: (error) =>
          captureException(error, {
            tags: {
              [FileAwarenessMonitorErrorTypeTag]: FileAwarenessMonitorErrorsList.FailedToAppendParameter,
            },
          }),
      })}
      fillAllSpace
      config={playerConfig}
    />
  </div>
);
